import { createAction, props } from '@ngrx/store';

// Models
import { AccountType } from "src/app/accounts-v2/models/fields/accountType.model";
import { AnnualRevenue } from "../../model/annualRevenue.model";
import { Currency } from "../../model/currency.model";
import { EmployeeCount } from "../../model/employeeCount.model";
import { Industry } from "../../model/industry.model";
import { Ownership } from "../../model/ownership.model";
import { Rating } from "../../model/rating.model";
import { Timezone } from "../../model/timezone.model";

// Actions for Account Types
export const getAccountTypes = createAction('[ACCOUNT_TYPES] - GET_ACCOUNT_TYPES');
export const beginGetAccountTypes = createAction('[ACCOUNT_TYPES] - BEGIN_GET_ACCOUNT_TYPES');
export const successGetAccountTypes = createAction('[ACCOUNT_TYPES] - SUCCESS_GET_ACCOUNT_TYPES', props<{ payload: AccountType[] }>());
export const errorAccountTypes = createAction('[ACCOUNT_TYPES] - Error', props<any>());

// Actions for Annual Revenues
export const getAnnualRevenues = createAction('[ANNUAL_REVENUES] - GET_ANNUAL_REVENUES');
export const beginGetAnnualRevenues = createAction('[ANNUAL_REVENUES] - BEGIN_GET_ANNUAL_REVENUES');
export const successGetAnnualRevenues = createAction('[ANNUAL_REVENUES] - SUCCESS_GET_ANNUAL_REVENUES', props<{ payload: AnnualRevenue[] }>());
export const errorAnnualRevenues = createAction('[ANNUAL_REVENUES] - Error', props<any>());

// Actions for Currencies
export const getCurrencies = createAction('[CURRENCIES] - GET_CURRENCIES');
export const beginGetCurrencies = createAction('[CURRENCIES] - BEGIN_GET_CURRENCIES');
export const successGetCurrencies = createAction('[CURRENCIES] - SUCCESS_GET_CURRENCIES', props<{ payload: Currency[] }>());
export const errorCurrencies = createAction('[CURRENCIES] - Error', props<any>());

// Actions for Employee Counts
export const getEmployeeCounts = createAction('[EMPLOYEES] - GET_EMPLOYEES');
export const beginGetEmployeeCounts = createAction('[EMPLOYEES] - BEGIN_GET_EMPLOYEES');
export const successGetEmployeeCounts = createAction('[EMPLOYEES] - SUCCESS_GET_EMPLOYEES', props<{ payload: EmployeeCount[] }>());
export const errorEmployeeCounts = createAction('[EMPLOYEES] - Error', props<any>());

// Actions for Industries
export const getIndustries = createAction('[INDUSTRIES] - GET_INDUSTRIES');
export const beginGetIndustries = createAction('[INDUSTRIES] - BEGIN_GET_INDUSTRIES');
export const successGetIndustries = createAction('[INDUSTRIES] - SUCCESS_GET_INDUSTRIES', props<{ payload: Industry[] }>());
export const errorIndustries = createAction('[INDUSTRIES] - Error', props<any>());

// Actions for Ownerships
export const getOwnerships = createAction('[OWNERSHIPS] - GET_OWNERSHIPS');
export const beginGetOwnerships = createAction('[OWNERSHIPS] - BEGIN_GET_OWNERSHIPS');
export const successGetOwnerships = createAction('[OWNERSHIPS] - SUCCESS_GET_OWNERSHIPS', props<{ payload: Ownership[] }>());
export const errorOwnerships = createAction('[OWNERSHIPS] - Error', props<any>());

// Actions for Ratings
export const getRatings = createAction('[RATINGS] - GET_RATINGS');
export const beginGetRatings = createAction('[RATINGS] - BEGIN_GET_RATINGS');
export const successGetRatings = createAction('[RATINGS] - SUCCESS_GET_RATINGS', props<{ payload: Rating[] }>());
export const errorRatings = createAction('[RATINGS] - Error', props<any>());

// Actions for Timezones
export const getTimezones = createAction('[TIMEZONES] - GET_TIMEZONES');
export const beginGetTimezones = createAction('[TIMEZONES] - BEGIN_GET_TIMEZONES');
export const successGetTimezones = createAction('[TIMEZONES] - SUCCESS_GET_TIMEZONES', props<{ payload: Timezone[] }>());
export const errorTimezones = createAction('[TIMEZONES] - Error', props<any>());